import { FieldPrimaryListDto } from "@common/dto/field/list-primary-dto";
import { FolderPrimaryListDto } from "@common/dto/folder/primary-list-dto";
import {
  ResponseFieldType,
  SpreadsheetType,
} from "@modules/spreadsheets/dto/spreadsheet/type";

export type InternalFieldPrimaryList = FieldPrimaryListDto & {
  internalId: number;
  fullPath: string;
  parentField?: InternalParentFieldList;
  editable?: boolean;
  lookupValues?: Record<string, string[]> | {};
  dropdownValues?: string[];
};

export type InternalParentFieldList = {
  fieldname?: string;
  fieldid?: number;
  fieldtype?: ResponseFieldType;
  id: number;
  name: string;
  context: number;
  type: number;
  system: boolean;
  fullPath: string;
  imageURL: string;
  options: any;
  parentField: any;
};

export type SpreadsheetManagementProps = {
  spreadsheetType: SpreadsheetType;
  propsSpreadsheetId: number;
  onModeSwitch?: (mode: 'results' | 'management') => void;
  initialFolderId?: number;
  initialFamilyId?: number;
};

export type SpreadsheetManagementDraggedField = {
  id: number | string;
  folder: FolderPrimaryListDto;
  field: InternalFieldPrimaryList;
  parentField?: InternalParentFieldList;
  editable?: boolean;
  lookupValues?: Record<string, string[]> | {};
  modulo?: number;
  width?: number;
};

export enum SpreadsheetManagementSortDirection {
  ascending = "ascending",
  descending = "descending",
}

export type SpreadsheetManagementSortTableField =
  SpreadsheetManagementDraggedField & {
    direction?: SpreadsheetManagementSortDirection;
  };
